import React from "react";
import { ImageOff } from "lucide-react";
import "./ProductImagePlaceholder.css";

const ProductImagePlaceholder = () => (
  <div aria-hidden="true" className="product-image-placeholder">
    <ImageOff size={20} strokeWidth={1.8} />
  </div>
);

export default ProductImagePlaceholder;
